.outreach-running-signal::after {
    content: '';
    position: absolute;
    inset: 1px;
    border: 1px solid currentColor;
    border-radius: 50%;
    opacity: 0.35;
    animation: outreach-signal-breathe 2.8s ease-in-out infinite;
}

@keyframes outreach-signal-breathe {
    0%,
    100% {
        transform: scale(0.7);
        opacity: 0.25;
    }
    50% {
        transform: scale(1.25);
        opacity: 0.65;
    }
}

@media (prefers-reduced-motion: reduce) {
    .outreach-running-signal::after {
        animation: none;
    }
}
